/**
 * Which Szondi portrait URLs to show and warm.
 * The live grid and the preload list use WebP only. PNG rows are accepted so
 * callers can prove the fallback files never enter the network plan.
 */

/**
 * @param {string[][] | unknown} rows
 * @param {number} series 1-based
 * @returns {string[]}
 */
export function webpUrlsForSeries(rows, series) {
  if (!Array.isArray(rows)) return []
  const row = rows[series - 1]
  if (!Array.isArray(row)) return []
  // Keep slot indexes. An empty string means "do not retarget this portrait".
  return row.map((src) => (typeof src === "string" ? src : ""))
}

/**
 * WebP URLs for every series except the one already on screen.
 * @param {string[][] | unknown} webpRows
 * @param {number} currentSeries 1-based
 * @returns {string[]}
 */
export function webpUrlsToWarm(webpRows, currentSeries) {
  if (!Array.isArray(webpRows)) return []
  const urls = []
  webpRows.forEach((row, index) => {
    if (index + 1 === currentSeries) return
    webpUrlsForSeries(webpRows, index + 1).forEach((src) => {
      if (src) urls.push(src)
    })
  })
  return urls
}

/**
 * @param {string[][] | unknown} rows
 * @returns {Set<string>}
 */
function urlSet(rows) {
  const urls = new Set()
  if (!Array.isArray(rows)) return urls
  rows.forEach((row) => {
    if (!Array.isArray(row)) return
    row.forEach((src) => {
      if (typeof src === "string" && src) urls.add(src)
    })
  })
  return urls
}

/**
 * @param {{
 *   webpRows?: string[][],
 *   pngRows?: string[][],
 *   series: number,
 *   appliedSeries: number | null
 * }} input
 * @returns {{ sync: boolean, urls: string[], warm: string[] }}
 */
export function portraitPreloadPlan({ webpRows, pngRows, series, appliedSeries }) {
  const blocked = urlSet(pngRows)
  const sync = appliedSeries !== series
  const urls = sync
    ? webpUrlsForSeries(webpRows, series).map((src) => (src && !blocked.has(src) ? src : ""))
    : []
  const warm = webpUrlsToWarm(webpRows, series).filter((src) => !blocked.has(src))
  return { sync, urls, warm }
}
